export type ImageVariantWidth = 384 | 768 | 1280 | 2048;

const imageVariantWidths = new Set<ImageVariantWidth>([384, 768, 1280, 2048]);
const supportedImagePath = /^\/(?:wechat\/mp|legacy|images\/(?:brand|advisor-avatars)|operations)\/.*\.(?:jpe?g|png|webp)$/i;

/** Build a responsive URL without changing the canonical asset path. */
export function imageVariantUrl(value: string, width: ImageVariantWidth): string {
  const source = value.trim();
  if (!source || !imageVariantWidths.has(width) || source.includes("?") || source.includes("#") || source.startsWith("//")) return value;

  let url: URL;
  try {
    url = new URL(source, window.location.origin);
  } catch {
    return value;
  }

  if (url.pathname.startsWith("/image/") || !supportedImagePath.test(url.pathname)) return value;

  const isAbsolute = /^https?:\/\//i.test(source);
  const isFirstParty = url.origin === window.location.origin
    || url.hostname === "shapemoto.com"
    || url.hostname.endsWith(".shapemoto.com");
  if (isAbsolute && !isFirstParty) return value;

  const variantPath = `/image/${width}${url.pathname}`;
  return isAbsolute ? `${url.origin}${variantPath}` : variantPath;
}
